module.exports = __webpack_public_path__ + "static/media/watiga-logo.26f509c1.jpeg";